/// <amd-module name="Widgets/SprintBurndownConfig/CommonConfigRenderer" />
import * as React from "react";
import * as Core from "Tfs/Platform/Contracts/Core";
import { FormatComponent } from "VSS/Platform/Components/Format/Format";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { Checkbox } from "VSSUI/Checkbox";
import { FormItem } from "VSSUI/FormItem";
import { Link } from "VSSUI/Link";
import { IListBoxItem } from "VSSUI/ListBox";
import { GenericSelectionDropdown } from "Widgets/Configs/Common/GenericSelectionDropdown";
import * as Resources from "Widgets/SprintBurndownConfig/Resources";

// This covers the render paths which are identical between Ax and legacy burndown Config.

export function renderTeamPicker(
    onTeamSelect: (teamItem: IListBoxItem<Core.WebApiTeam>) => void,
    teamOptions: IListBoxItem<Core.WebApiTeam>[],
    selectedId: string
): JSX.Element | null {
    return (
        <FormItem label={Resources.TeamLabel} className="widget-config-form-item">
            <GenericSelectionDropdown className="team-picker" items={teamOptions} selectedId={selectedId} onSelect={onTeamSelect} />
        </FormItem>
    );
}

export function renderVersionToggle(
    onToggleLegacyMode: () => void,
    isInModernState: boolean,
    pageContext?: IVssPageContext,
    errorMessage?: string
): JSX.Element | null {
    return (
        <FormItem label={Resources.VersionLabel} className="widget-config-form-item" error={errorMessage !== null} message={errorMessage}>
            {FormatComponent({
                format: Resources.NewVersionAvailableLabel,
                children: (
                    <Link href={"https://go.microsoft.com/fwlink/?linkid=2096311"} target={"_blank"}>
                        {Resources.LearnMoreText}
                    </Link>
                )
            })}
            <Checkbox
                label={Resources.ModernModeToggleLabel}
                onChange={onToggleLegacyMode}
                checked={isInModernState}
                disabled={!isAnalyticsEnabled(pageContext)}
            ></Checkbox>
        </FormItem>
    );
}

function isAnalyticsEnabled(pageContext: IVssPageContext | undefined): boolean {
    if (!pageContext) {
        return true;
    }

    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    // Modern widgets contribution being loaded is conditional on whether AX is enabled ,so we can use that to determine whether we need to disable upgrade toggle
    return contributionService.getContribution<any>("ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.AnalyticsSprintBurndownWidget");
}
